import { Subject } from 'rxjs';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CitiService } from '@sg/api/citi-service';
import { STEPPER_INDEX_MAP } from '../../../inspector-wizard-dialog.component';
import { SWIFT_FORWARDING_OUTBOUND_COLUMNS } from '../../../files-table/inspector-table-columns';

@Component({
  selector: 'sg-inspector-outbound-from-expanded',
  templateUrl: './inspector-outbound-from-expanded.component.html',
  styleUrls: ['./inspector-outbound-from-expanded.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SgInspectorOutboundFromExpandedComponent {
  @Input() outboundTableData$: Subject<CitiService.OutboundSwiftDto[]>;
  @Input() outboundFileContent$: Subject<string>;
  @Input() expandedSearchCriteria: {
    keys: Array<string>;
    values: Array<string | number>;
  };
  @Output() onClickNavigationButton = new EventEmitter<keyof typeof STEPPER_INDEX_MAP>();
  @Output() onClickClose = new EventEmitter<null>();
  @Output() onClickRow = new EventEmitter<string>();
  @Output() onClickDownloadFile = new EventEmitter<string>();
  outboundColumns = SWIFT_FORWARDING_OUTBOUND_COLUMNS;

  clickNavigateButton(nextStep: keyof typeof STEPPER_INDEX_MAP): void {
    this.onClickNavigationButton.emit(nextStep);
  }
}
